import { AppMain } from '@/locales/samples/AppMain/en-US';
import { HelloWorld } from '@/locales/samples/HelloWorld/en-US';

import {
  Menue,
  UserInfo,
  FormParts,
  ApiErrorMessage,
  InputErrorMessage,
  Button,
} from '@/locales/common/en-US';
import { Dialog } from '@/locales/common/en-US';
import { Dispensing } from '@/locales/Dispensing/en-US';
import { DispensingReadyCalling } from '@/locales/DispensingReadyCalling/en-US';
import { ExplainMedicine } from '@/locales/ExplainMedicine/en-US';
import { Delivery } from '@/locales/Delivery/en-US';
import { Home } from '@/locales/Home/en-US';
import { InfoNotice } from '@/locales/InfoNotice/en-US';
import { MedicalInterview } from '@/locales/MedicalInterview/en-US';
import { Pharmacy } from '@/locales/Pharmacy/en-US';
import { HomeModifyResend } from '@/locales/HomeModifyResend/en-US';
import { TakingMedicineSchedule } from '@/locales/TakingMedicineSchedule/en-US';
import { Reservation } from '@/locales/Reservation/en-US';
import { HomeService } from '@/locales/HomeService/en-US';
import { MedicationAlarm } from '@/locales/MedicationAlarm/en-US';
import { MedicineList } from '@/locales/MedicineList/en-US';
import {
  MyPage,
  EditUser,
  EditEmailAddress,
  UpdatedDialog,
  LicencePage,
} from '@/locales/MyPage/en-US';
import { FamilyList } from './FamilyList/en-US';
import { ServiceList } from '@/locales/ServiceList/en-US';
import { ServiceListEdit } from '@/locales/ServiceListEdit/en-US';
import { FirstAccess } from '@/locales/FirstAccess/en-US';
import { StringMark } from '@/locales/common/en-US';
import { SpecialString } from '@/locales/common/en-US';
import { CallSettings } from '@/locales/CallSettings/en-US';
import { TermsOfUse } from '@/locales/TermsOfUse/en-US';
import { VitalData } from '@/locales/VitalData/en-US';
import { CreditCard } from '@/locales/CreditCard/en-US';
import { PersonalInformationDisclosure } from '@/locales/PersonalInformationDisclosure/en-US';
import { DeliveryAddress } from '@/locales/DeliveryAddress/en-US';
import { ReservationHistory } from '@/locales/ReservationHistory/en-US';
import { DataShare } from '@/locales/DataShare/en-US';
import { FollowUpMessage } from '@/locales/FollowUp/en-US';
import { AppLinkageSettings } from './AppLinkageSettings/en-US';
import { UploadImages } from './UploadImages/en-US';
import { TakingMedicineRecord } from '@/locales/TakingMedicineRecord/en-US';
import { TakingMedicineCheck } from '@/locales/TakingMedicineCheck/en-US';
import { ErrorHandle } from '@/locales/ErrorHandle/en-US';
import { PrivacyPolicy } from '@/locales/PrivacyPolicy/en-US';
import { FuncIntro } from '@/locales/FuncIntro/en-US';
import { EcShop } from '@/locales/EcShop/en-US';
import { PrescriptionQR } from '@/locales/PrescriptionQR/en-US';
import { DataLink } from '@/locales/DataLink/en-US';
import { Ubie } from '@/locales/Ubie/en-US';
import { HealthCheck } from '@/locales/HealthCheck/en-US';
import { Corporation } from '@/locales/Corporation/en-US';
import { YJMedicine } from '@/locales/YJMedicine/en-US';
import { CameraAccess } from '@/locales/CameraAccess/en-US';
import { SettlementConfirmation } from '@/locales/SettlementConfirmation/en-US';
import { MynaPortal } from '@/locales/MynaPortal/en-US';
import {
  CardRegisterErrorMessage,
  CardRegisterSettlementErrorMessage,
} from '@/locales/DgftDisplayErrorMessage/ja-JP';
import { QRCodeSetting } from '@/locales/QRCodeSetting/en-US';

export const localeEnUS = {
  AppMain,
  HelloWorld,
  Menue,
  Dialog,
  Dispensing,
  DispensingReadyCalling,
  ExplainMedicine,
  Delivery,
  Home,
  InfoNotice,
  MedicalInterview,
  Pharmacy,
  HomeModifyResend,
  TakingMedicineSchedule,
  Reservation,
  HomeService,
  MedicationAlarm,
  MedicineList,
  MyPage,
  EditUser,
  EditEmailAddress,
  UpdatedDialog,
  LicencePage,
  UserInfo,
  FamilyList,
  FormParts,
  ServiceList,
  ServiceListEdit,
  FirstAccess,
  StringMark,
  SpecialString,
  ApiErrorMessage,
  InputErrorMessage,
  CallSettings,
  TermsOfUse,
  VitalData,
  CreditCard,
  PersonalInformationDisclosure,
  DeliveryAddress,
  ReservationHistory,
  DataShare,
  FollowUpMessage,
  AppLinkageSettings,
  UploadImages,
  TakingMedicineRecord,
  TakingMedicineCheck,
  ErrorHandle,
  PrivacyPolicy,
  FuncIntro,
  EcShop,
  PrescriptionQR,
  Button,
  DataLink,
  Ubie,
  HealthCheck,
  Corporation,
  YJMedicine,
  CameraAccess,
  SettlementConfirmation,
  MynaPortal,
  CardRegisterErrorMessage,
  CardRegisterSettlementErrorMessage,
  QRCodeSetting,
};
